import { render, staticRenderFns } from "./FullPageLayout.vue?vue&type=template&id=2f8cc62b&scoped=true&"
import script from "./FullPageLayout.vue?vue&type=script&lang=js&"
export * from "./FullPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./FullPageLayout.vue?vue&type=style&index=0&id=2f8cc62b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8cc62b",
  null
  
)

export default component.exports